import { render, staticRenderFns } from "./EditBlockNavigationTabCart.vue?vue&type=template&id=30b2d9f4&"
import script from "./EditBlockNavigationTabCart.vue?vue&type=script&lang=js&"
export * from "./EditBlockNavigationTabCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports